var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil172(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006664",
    d: "M978.1248 45.8752C949.3504 17.1008 911.104 1.28 870.4 1.28s-78.9504 15.8208-107.7248 44.5952l-652.8 652.8a25.3952 25.3952 0 0 0-5.9392 9.3696l-102.4 281.6a25.6 25.6 0 0 0 32.8192 32.768l281.6-102.4a26.112 26.112 0 0 0 9.3696-5.9392l652.8-652.8c28.7744-28.7744 44.5952-67.0208 44.5952-107.7248s-15.8208-78.9504-44.5952-107.7248zM293.12 873.8816l-224.7168 81.7152 81.7152-224.7168L716.8 164.1984 859.8016 307.2 293.12 873.8816zM941.8752 225.0752l-45.8752 45.8752-143.0016-143.0016 45.8752-45.8752c19.0976-19.0976 44.4928-29.5936 71.4752-29.5936s52.3776 10.496 71.4752 29.5936 29.5936 44.4928 29.5936 71.4752-10.496 52.3776-29.5936 71.4752z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil172);
export default __webpack_public_path__ + "static/media/pencil-172.e88ced8b45762432de572f2686d9b796.svg";
export { ForwardRef as ReactComponent };